import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideo, faUsers, faGlobe } from '@fortawesome/free-solid-svg-icons';
import heroLogo from '../../../images/LandingPage_Hero.png';
const FEATURES = [
  { icon: faVideo,  titleKey: 'Create your EPK',      descKey: 'Professional Electronic Press Kits for your films' },
  { icon: faUsers,  titleKey: 'Find collaborators',   descKey: 'Connect with filmmakers, actors, and crew' },
  { icon: faGlobe,  titleKey: 'Reach distributors',   descKey: 'Get your film in front of the right people' },
];

function AuthLeftPanel() {
  const { t } = useTranslation();

  return (
    <div className="kk-dark-section tw-hidden lg:tw-flex tw-w-[45%] tw-shrink-0 tw-flex-col tw-justify-between tw-bg-gradient-to-br tw-from-[#1E0039] tw-to-[#09010f] tw-px-12 tw-py-10 tw-relative tw-overflow-hidden">
      <div className="tw-absolute tw-top-[-120px] tw-left-[-120px] tw-w-[400px] tw-h-[400px] tw-rounded-full tw-bg-[#FF43A7]/10 tw-blur-[100px] tw-pointer-events-none" />
      <div className="tw-absolute tw-bottom-[-80px] tw-right-[-60px] tw-w-[300px] tw-h-[300px] tw-rounded-full tw-bg-[#FF43A7]/8 tw-blur-[80px] tw-pointer-events-none" />

      <div className="tw-relative tw-flex tw-flex-col">
        <div className="tw-flex tw-flex-col tw-items-center tw-text-center tw-py-[25px]">
          <img src={heroLogo} alt="KinoKlik" className="tw-h-16 tw-w-16 tw-object-contain tw-mb-3" />
          <span className="tw-text-2xl tw-font-bold tw-tracking-wide tw-text-white">KinoKlik</span>
        </div>

        <div className="tw-pt-[60px] tw-pb-[25px]">
          <h2 className="tw-mb-4 tw-text-4xl tw-font-bold tw-leading-tight tw-text-white">
            {t("The platform for film industry professionals")}
          </h2>
          <p className="tw-mb-10 tw-text-base tw-leading-relaxed tw-text-gray-400">
            {t("Build your portfolio, connect with collaborators, and get your film seen.")}
          </p>
          <div className="tw-flex tw-flex-col tw-gap-6">
            {FEATURES.map(({ icon, titleKey, descKey }) => (
              <div key={titleKey} className="tw-flex tw-items-start tw-gap-4">
                <div className="tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-[#FF43A7]/30 tw-bg-[#FF43A7]/15">
                  <FontAwesomeIcon icon={icon} className="tw-text-sm tw-text-[#FF43A7]" />
                </div>
                <div>
                  <p className="tw-text-sm tw-font-semibold tw-text-white">{t(titleKey)}</p>
                  <p className="tw-mt-0.5 tw-text-xs tw-text-gray-500">{t(descKey)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthLeftPanel;
